import { operatorNotificationApi } from './operator-notification.api';
import { operatorAiApi } from './operator-ai.api';
import { operatorBillingApi } from './operator-billing.api';
import { operatorFeedbackApi } from './operator-feedback.api';
import { operatorLogsApi } from './operator-logs.api';
import { operatorReportApi } from './operator-report.api';
import { operatorBatchApi } from './operator-batch.api';
import { operatorSettingsApi } from './operator-settings.api';
import { operatorTenantApi } from './operator-tenant.api';
import { operatorApiPlatformApi } from './operator-api-platform.api';
import { operatorOpsApi } from './operator-ops.api';
import { operatorFeatureFlagApi } from './operator-feature-flag.api';
import { operatorOutboxApi } from './operator-outbox.api';

export { operatorNotificationApi } from './operator-notification.api';
export { operatorAiApi } from './operator-ai.api';
export { operatorBillingApi } from './operator-billing.api';
export { operatorFeedbackApi } from './operator-feedback.api';
export { operatorLogsApi } from './operator-logs.api';
export { operatorReportApi } from './operator-report.api';
export { operatorBatchApi } from './operator-batch.api';
export { operatorSettingsApi } from './operator-settings.api';
export { operatorTenantApi } from './operator-tenant.api';
export { operatorApiPlatformApi } from './operator-api-platform.api';
export { operatorOpsApi } from './operator-ops.api';
export { operatorFeatureFlagApi } from './operator-feature-flag.api';
export { operatorOutboxApi } from './operator-outbox.api';

export const operatorApi = {
  ...operatorAiApi,
  ...operatorSettingsApi,
  ...operatorTenantApi,
  ...operatorLogsApi,
  ...operatorReportApi,
  ...operatorBatchApi,
  ...operatorFeedbackApi,
  ...operatorNotificationApi,
  ...operatorApiPlatformApi,
  ...operatorOpsApi,
  ...operatorFeatureFlagApi,
  ...operatorOutboxApi,
  // billing last so getUsage maps to /operator/usage (not api-platform)
  ...operatorBillingApi,
};
